import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { RemovedItemsDialogPageRoutingModule } from './removed-items-dialog-routing.module';

import { RemovedItemsDialogPage } from './removed-items-dialog.page';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		CommonModule,
		FormsModule,
		RemovedItemsDialogPageRoutingModule,
		TranslateModule
	],
	declarations: [RemovedItemsDialogPage]
})
export class RemovedItemsDialogPageModule { }

